import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Divider, Box, Avatar, Stack, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ProductionCategoryItemDetails = ({ category_item, onClose }) => {
    if (!category_item) return <Typography variant="h6">Select a category item to view details</Typography>;

    const formatCurrency = (amount) => {
        if (amount == null) { // Check for null or undefined
            return ''; // Return empty string if amount is null or undefined
        }

        return new Intl.NumberFormat('en-IE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    };

    const tableHeaders = [
        { label: 'Field', width: '30%' },
        { label: 'Value', width: '70%' },
    ];

    const tableData = [
        { field: 'Παραγωγή', value: category_item?.prod_descr.p_descr },
        //{ field: 'Production Category', value: category_item?.prod_categ_descr.pci_descr },
        { field: 'Περιγραφή', value: category_item?.pci_descr },
        { field: 'Τρόπος Τιμολόγησης', value: category_item?.pci_type_descr || '-' },
        { field: 'Προϋπολογισμός', value: formatCurrency(category_item?.pci_amount) },
        { field: 'Παρατηρήσεις', value: category_item?.pci_notes },
    ];

    return (
        <Paper elevation={3} sx={{ padding: 2, borderRadius: 2, backgroundColor: '#f4f6f8', height: '100%' }}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                    {/* TITLE ? */}
                </Stack>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Stack>
            <Divider sx={{ marginBottom: 2 }} />
            <TableContainer component={Box}>
                <Table>
                    <TableBody>
                        {tableData.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>{row.field}</TableCell>
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>{row.value}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default ProductionCategoryItemDetails;